import { Tab, Tabs } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

/**
 * Navegação entre operação e relatórios (mesmo padrão visual de relatórios do app).
 */
export function CashRegisterSectionTabs() {
  const { pathname } = useLocation();
  const reportsActive =
    pathname.startsWith("/caixa/relatorio") ||
    pathname.startsWith("/caixa/sessao");
  const value = reportsActive ? "relatorio" : "operacao";

  return (
    <Tabs
      value={value}
      sx={{
        mb: 3,
        minHeight: 44,
        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: 700,
          fontSize: 15,
          minHeight: 44,
        },
      }}
    >
      <Tab label="Operação" value="operacao" component={Link} to="/caixa" />
      <Tab
        label="Relatórios por dia"
        value="relatorio"
        component={Link}
        to="/caixa/relatorio"
      />
    </Tabs>
  );
}
